import type { InternalUserSchedule } from '../../Scenario';

export function migrateScenarioAddFreightByShipmentClientId(
  scenario: InternalUserSchedule,
): InternalUserSchedule {
  if (
    scenario.freightByShipmentClientId instanceof Map &&
    scenario.extraFreightByShipmentClientId instanceof Map
  ) {
    return scenario;
  }

  return Object.assign(scenario, {
    freightByShipmentClientId:
      scenario.freightByShipmentClientId instanceof Map
        ? scenario.freightByShipmentClientId
        : new Map(),
    extraFreightByShipmentClientId:
      scenario.extraFreightByShipmentClientId instanceof Map
        ? scenario.extraFreightByShipmentClientId
        : new Map(),
  });
}
